import React, {useState} from "react";
import {Col, Row, Button} from "react-bootstrap";

import {InputWithLabel} from "../../component/Form/InputWithLabel";
import {dayMonthYearAtTimeWithSeconds} from "../../utils/dates";
import Icon from "../../component/Icon/Icon";
import NodeStatusSelector, {
  NODE_STATUS_TYPES
} from "../component/NodeStatusSelector";
import {ModalMessage} from "../../component/Modal/ModalMessage";
import NodeService from "./NodeService";
import Notify from "../../services/Notify";

class NodeGrid {
  title = 'Lista de Nodes';
  showNewButton = true;
  newUrl = '/nodes/new'
  customFilters = {
    nodeStatus: NODE_STATUS_TYPES.BOTH
  }

  async onResetNode(id) {
    const nodeService = new NodeService()
    await Notify.promise(nodeService.resetNode(id), {
      pending: 'Resetando node',
      success: 'Node resetado com sucesso',
      error: 'Houve um erro ao resetar o node'
    })
  }

  columns = [
    {
      Header: "Nome",
      accessor: "friendlyName",
      HeaderColumn: true,
    },
    {
      Header: "UUID",
      accessor: "uuid"
    },
    {
      Header: "Antenas",
      accessor: "antennas.uuid",
      Cell: row => (
          <div>  {(row.original.antennas || []).map(({uuid}) => {
            return <h6 key={uuid}>{uuid}</h6>
          })}
          </div>
      )
    },
    {
      Header: "Data do último ping",
      accessor: "nodeDetail.dateLastPing",
      sortable: false,
      Cell: ({original}) => original.nodeDetail
      && original.nodeDetail.dateLastPing ? dayMonthYearAtTimeWithSeconds(
          original.nodeDetail.dateLastPing) : 'Sem dados'
    },
    {
      Header: "Status",
      sortable: false,
      accessor: "nodeDetail.online",
      Cell: ({original}) => {
        const isOnline = original.nodeDetail && original.nodeDetail.online
        const iconStyle = {color: isOnline ? 'green' : 'red'}
        return (
            <Icon style={iconStyle} icon={isOnline ? 'check' : 'times'}/>
        )
      }
    },
    {
      Header: "Opções",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => {
        const [showModal, setShowModal] = useState(false)
        return (
            <Row className="h-100 flex-column">
              <Button bsSize="sm"
                      href={`#/nodes/${row.original.id}/node-pings`}
                      bsStyle="success" block>
                Pings
              </Button>
              <Button bsSize="sm"
                      href={`#/nodes-sensing/${row.original.id}`}
                      bsStyle="success" block>
                Leituras
              </Button>
              <Button bsSize="sm"
                      bsStyle="success"
                      href={"#/nodes/" + row.original.id + "/edit"} block>
                Editar</Button>
              <Button bsSize="sm" bsStyle="success" block
                      onClick={() => setShowModal(true)}>Resetar node</Button>
              <ModalMessage
                  title="Deseja resetar o node?"
                  showModal={showModal}
                  handleShowModal={setShowModal}
                  successButtonAction={() => this.onResetNode(
                      row.original.id)}/>
            </Row>
        )
      }
    }
  ];

  customFilterComponent = (_props, _state, onChange) => {
    const handleSimpleInput = (customFilterProperty, value) => {
      this.customFilters[customFilterProperty] = value;
      onChange(this.customFilters);
    }

    return (
        <Row className="align-items-center">
          <Col md={4}>
            <InputWithLabel
                label="Nome"
                onChangeText={text => handleSimpleInput('friendlyName', text)}
            />
          </Col>
          <Col md={4}>
            <InputWithLabel
                label="UUID"
                onChangeText={text => handleSimpleInput('uuid', text)}
            />
          </Col>
          <Col md={4}>
            <NodeStatusSelector
                defaultValue={this.customFilters.nodeStatus}
                setValue={(value) => handleSimpleInput('nodeStatus', value)}
            />
          </Col>
        </Row>
    )
  }

  endpoint = () => {
    const params = new URLSearchParams({})
    const {friendlyName, uuid, nodeStatus} = this.customFilters

    friendlyName && params.append('friendlyName', friendlyName)
    uuid && params.append('uuid', uuid)

    switch (nodeStatus) {
      case NODE_STATUS_TYPES.ONLY_OFFLINE.id:
        params.append('isOffline', true)
        break;
      case NODE_STATUS_TYPES.ONLY_ONLINE.id:
        params.append('isOnline', true)
        break;
      default:
        break;
    }

    return `cloud/v1/nodes?${params.toString()}`;
  }
}

export default NodeGrid;



// WEBPACK FOOTER //
// ./src/gateways/node/NodesGrid.js